import React from 'react';
import { Lock, Wand2 } from 'lucide-react';

// Categories attached automatically because the selected sub-categories also exist there (locked while the sub-category is selected)
export const AutoCategoriesBlock = ({ categories, auto }) => {
  const nameOf = (slug) => categories.find(c => c.slug === slug)?.name || slug;
  return (
    <div className="md:col-span-2 border border-blue-200 rounded-lg p-3 bg-blue-50/60" data-testid="product-auto-categories">
      <div className="flex items-center justify-between mb-2">
        <div>
          <p className="text-xs font-medium text-blue-900 flex items-center gap-1.5"><Wand2 className="w-3.5 h-3.5" /> Catégories automatiquement associées</p>
          <p className="text-[11px] text-blue-700/80">Chaque sous-catégorie sélectionnée est rattachée à toutes les catégories où elle existe. Ces associations suivent la sous-catégorie et ne peuvent pas être retirées ici.</p>
        </div>
        <span className="text-[11px] text-blue-800 font-semibold" data-testid="product-auto-categories-count">{auto.length}</span>
      </div>
      {auto.length === 0 ? (
        <p className="text-xs text-blue-700/70" data-testid="product-auto-categories-empty">Aucune autre catégorie ne contient la ou les sous-catégories sélectionnées.</p>
      ) : (
        <ul className="flex flex-wrap gap-1.5">
          {auto.map(x => (
            <li key={`${x.category}::${x.subcategory}`} data-testid={`product-auto-category-${x.category}`} className="inline-flex items-center gap-1.5 text-xs bg-white border border-blue-200 text-gray-800 rounded-full pl-2.5 pr-1.5 py-1">
              <input type="checkbox" checked readOnly disabled className="h-3 w-3 accent-blue-600" aria-label={nameOf(x.category)} />
              <span className="font-medium">{nameOf(x.category)}</span>
              <span className="text-gray-400">· {x.subcategory}</span>
              <span className="inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide bg-blue-600 text-white rounded-full px-1.5 py-0.5"><Lock className="w-2.5 h-2.5" /> Auto</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCategoriesBlock;
